module.exports = __webpack_public_path__ + "img/user_photo.775cfe31.png";